import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../components/Loading";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import i18next from "i18next";
import { toast } from "react-toastify";
import moment, { lang } from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import { Plus } from "lucide-react";
import HampersTable from "./HampersTable";
import CreateHamper from "./CreateHampers";
import { Breadcrumb, Drawer, Modal } from "antd";
import {
  DoubleRightOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import dummy_image from "../../assets/Images/gallery.svg";

const AllHampers = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [mainLoading, setMainLoading] = useState(false);
  const [query, setquery] = useState("");
  const [allHampers, setAllHampers] = useState([]);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const [showComponent, setShowComponent] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [hamperLines, setHamperLines] = useState([]);
  const [drawerData, setDrawerData] = useState(null);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const userData = useSelector((state) => state?.login?.user?.result);

  useEffect(() => {
    GetAllHampers(query);
  }, [currentLimit, currentOffset]);

  const GetAllHampers = async (val) => {
    try {
      const payload = {
        company_id: userData?.company_id,
        limit: currentLimit,
        offset: currentOffset,
        search: val,
      };
      const res = await axiosInstance.post(URLS.GET_ALL_HAMPERS, payload);
      if (res?.data?.result[0]?.status_code == 200) {
        setAllHampers(res?.data?.result[0]?.data);
      } else {
        setAllHampers([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      setloading(false);
      // setLoading(false);
    }
  };

  const handleRowClick = async (order) => {
    setDrawerVisible(true);
    setDrawerLoading(true);
    setDrawerData(order);

    console.log("vdfggv", order);

    try {
      const payload = {
        company_id: company_id,
        hamper_id: order.hamper_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await axiosInstance.post(URLS.GET_HAMPER_ITEMS, payload);

      if (res?.data?.result[0]?.status_code === 200) {
        setHamperLines(res?.data?.result[0]?.data || []);
      } else {
        setHamperLines([]);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      setDrawerLoading(false);
    }
  };

  const onClose = () => {
    setDrawerVisible(false);
    setHamperLines([]);
    setDrawerData(null);
  };

  const handleDeleteHamper = async (row) => {
    Modal.confirm({
      title: t("Are you sure you want to delete this hamper?"),
      icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
      // content: t("This action cannot be undone."),
      okText: t("Yes"),
      cancelText: t("No"),
      okButtonProps: {
        className: "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
      },
      onOk: async () => {
        const payload = {
          company_id: company_id,
          hamper_id: row?.hamper_id, // id from the GetProductTaxes
          is_delete: true,
        };
        try {
          const res = await axiosInstance.post(
            URLS.UPDATE_HAMPER_DETAILS,
            payload,
          );
          const res1 = res?.data;
          if (res1?.result[0]?.status_code === 200) {
            toast.success(t("Hamper Deleted Successfully"));
            GetAllHampers();
          } else {
            toast.error(t(res1?.result?.status));
          }
        } catch (error) {
          console.error("Error fetching KPI data:", error);
        } finally {
        }
      },
    });
    //     const payload = {
    //   company_id: company_id,
    //   hamper_id: row?.hamper_id, // id from the GetProductTaxes
    //   is_delete: true,
    // };
    // try {
    //   const res = await axiosInstance.post(URLS.UPDATE_HAMPER_DETAILS, payload);
    //   const res1 = res?.data;
    //   if (res1?.result[0]?.status_code === 200) {
    //     toast.success(t("Hamper deleted successfully"));
    //     GetAllHampers();
    //   } else {
    //     toast.error(t(res1?.result?.status));
    //   }
    // } catch (error) {
    //   console.error("Error fetching KPI data:", error);
    // } finally {
    // }
  };

  return (
    <>
      {mainLoading && <LoadingSpinner />}

      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <Navbar heading="Gift Hampers" />
        <div className="mx-2 mb-3 font-extrabold sm:mx-5">
          <Breadcrumb
            separator={<DoubleRightOutlined />}
            items={
              showComponent
                ? [
                    {
                      title: (
                        <span
                          className="cursor-pointer hover:bg-gray-200 hover:text-black"
                          onClick={() => {setShowComponent(false)
                      setEditRecord(null);
                          }}
                        >
                          {t("All Gift Hampers")}
                        </span>
                      ),
                      key: "All-Hampers",
                    },
                    {
                      title: editRecord?.hamper_id
                        ? t("Update Gift Hamper")
                        : t("Create Gift Hamper"),
                      key: "create-hamper",
                      // title: t("Create Branch"),
                      // key: "create-branch",
                    },
                  ]
                : []
            }
            className="relative mt-3 font-semibold"
          />
        </div>
        <div className="custom-scrollbar ms-1 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
          {/* <div className="font-extrabold mb-3"></div> */}

          <div className="mt-3">
            {!showComponent && (
              <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                <div className="flex w-full items-center gap-x-2 md:w-auto">
                  <SearchBox
                    showBarcode={true}
                    searchResult={(values) => {
                      setloading(true);
                      setquery(values);
                      setCurrentLimit(10);
                      setCurrentOffset(0);
                      GetAllHampers(values);
                    }}
                    placeholder={t("Search Gift Hampers")}
                    width={"100%"}
                    value={query}
                  />
                </div>
                {!userData?.is_sub_store &&
                  !userData?.is_warehouse && 
                  <div className="mx-1 mt-1 flex justify-end md:mx-8 md:mt-3">
                  <button
                    className="mx-0 flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue px-3 text-sm font-semibold text-white sm:mx-2 sm:w-auto"
                    // onClick={() => setCreateOpen(true)}
                    onClick={() => {
                      if (checkPermission("/pos/hampers", isGinne)) {
                        setShowComponent(true);
                      }
                    }}
                  >
                    <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />
                    <span>{t("Create Gift Hamper")}</span>
                  </button>
                </div>}
                
              </div>
            )}

            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                {!showComponent ? (
                  <HampersTable
                    additionalData={allHampers}
                    pagination={(values) => {
                      setCurrentLimit(values.limit);
                      setCurrentOffset(values.offset);
                    }}
                    onRowClick={handleRowClick}
                    canEdit={!userData?.is_sub_store && !userData?.is_warehouse}
                    handleEditClick={(row) => {
                      if (checkPermission("/pos/hampers", isGinne)) {
                        setEditRecord(row);
                        setShowComponent(true);
                      }
                    }}
                    DeleteProductTax={(row) => {
                      if (checkPermission("/pos/hampers", isGinne)) {
                        handleDeleteHamper(row);
                      }
                    }}
                  />
                ) : (
                  <CreateHamper
                    onClose={() => {
                      setShowComponent(false);
                      setEditRecord(null);
                    }}
                    handleReferesh={() => {
                      setCurrentLimit(10);
                      setCurrentOffset(0);
                      GetAllHampers();
                    }}
                    editRecord={editRecord}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <Drawer
          title={
            i18n.language == "ar"
              ? drawerData?.arabic_name
              : drawerData?.english_name
          }
          placement={i18n.language === "ar" ? "left" : "right"}
          width={typeof window !== "undefined" && window.innerWidth < 768 ? "95%" : 500}
          onClose={onClose}
          visible={drawerVisible}
          styles={{
            header: {
              color: "#1E3ABA", // Change this to your desired color
              fontWeight: "bold",
              fontSize: "20px",
            },
          }}
        >
          {drawerLoading ? (
            <div className="space-y-4 p-4">
              {/* Header Skeleton */}
              <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

              {/* Summary Skeleton */}
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
              </div>

              {/* Product Line Skeletons */}
              {[1, 2, 3].map((_, idx) => (
                <div
                  key={idx}
                  className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
                >
                  <div className="w-10 h-10 bg-gray-200 rounded"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  </div>
                  <div className="h-4 bg-gray-200 rounded w-10"></div>
                </div>
              ))}
            </div>
          ) : // <LoadingSpinner />
          // <div>{t("Loading order details...")}</div>
          hamperLines?.length > 0 ? (
            <div className="space-y-4">
              {/* Order Summary */}
              {/* <div className="space-y-1 text-sm font-medium">
                <p>
                  <strong>{t("Order Value :")}</strong> {drawerData.currency}{" "}
                  {drawerData.order_value}
                </p>
                <p>
                  <strong>{t("Total Amount :")}</strong> {drawerData.currency}{" "}
                  {drawerData.order_value}
                </p>
                <p>
                  <strong>{t("Number of Items :")}</strong> {drawerData.items}
                </p>
                <p>
                  <strong>{t("Payment Mode :")}</strong>{" "}
                  {drawerData.payment || "-"}
                </p>
                <p>
                  <strong>{t("Payment Status :")}</strong>{" "}
                  {drawerData.state || "-"}
                </p>
              </div> */}

              {/* Product Lines */}
              <div>
                {hamperLines.map((line, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center border rounded-lg bg-white p-2 mb-2 shadow-sm"
                  >
                    {/* Image */}
                    {line.image_url && line.image_url != '' ? 
                     <img
                      src={line.image_url || "/placeholder.png"}
                      alt={line.name}
                      className="w-10 h-10 object-contain rounded"
                    />
                    :
                      <img
                                        src={dummy_image}
                                        alt=""
                                        className="w-10 h-10 object-contain rounded"
                                      />
                    }

                    {/* Middle content: Name + Qty x Price */}
                    <div className="flex flex-col flex-1 mx-2">
                      <p className="font-semibold text-sm leading-tight">
                        {line.product_name2 && line.product_name2 != ""
                          ? line.product_name2
                          : line.product_name}
                      </p>
                      <p dir="ltr" className={`text-xs text-gray-600 ${i18n.language == 'ar' ? "text-right" : "text-left"}`}>
                        {`${line.qty_added} x EGP ${line.sale_price.toFixed(2)}`}
                      </p>
                    </div>

                    {/* Right: Total price */}
                    <p className="font-normal whitespace-nowrap text-right">
                      EGP {(line.sale_price * line.qty_added).toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className="text-center">{t("no_product_found")}</p>
          )}
        </Drawer>
      </div>
    </>
  );
};

export default AllHampers;
